/* eslint-disable */

import Vue from "vue";
import Router from "vue-router";
import store from "@/store/index.js"
import { REFRESH } from "@/store/mutations.type"

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
    scrollBehavior: function (to, from, savedPosition) {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 }
        }
    },
  routes: [
      {
          path: '/login/:organization?',
          name: 'login',
          component: () => import('./components/Login.vue'),
          meta: {},
      },
      {
          path: '/reset_password/request/:organization?',
          name: 'reset_password',
          component: () => import('./components/ResetPassword.vue'),
          meta: {},
      },
      {
          path: '/reset_password/:token',
          name: 'reset_password_token',
          component: () => import('./components/ResetPasswordToken.vue'),
          meta: {},
      },
      {
          path : '/:organization/register',
          name: 'register',
          component: () => import('./components/Register.vue'),
          meta: {},
      },
      {
          path : '/:organization/thank_you',
          name: 'thank_you',
          component: () => import('./components/ThankYou.vue'),
          meta: {},
      },
      {
          path : '/:organization/not_available',
          name: 'not_available',
          component: () => import('./components/ServiceAreaNotAvailable.vue'),
          meta: {},
      },
      {
          path : '/:organization/thank_you_monthly',
          name: 'thank_you_monthly',
          component: () => import('./components/ThankYouMonthly.vue'),
          meta: {},
      },
      {
          path : '/:organization/thank_you_not_available',
          name: 'thank_you_not_available',
          component: () => import('./components/ThankYouNotAvailable.vue'),
          meta: {},
      },
      {
          path: '/',
          name: 'dashboard',
          component: () => import('./components/Dashboard/Dashboard.vue'),
          meta: {},
      },
      {
          path: '/contact_info',
          name: 'contat_info',
          component: () => import('./components/ResidentialClients/ContactInfo/ContactInfo.vue'),
          meta: {
            type: 'residential',
          }
      },
      {
          path: '/location',
          name: 'location',
          component: () => import('./components/ResidentialClients/Location/Location.vue'),
          meta: {
            type: 'residential',
          }
      },
      {
          path: '/dog_info',
          name: 'dog_info',
          component: () => import('./components/ResidentialClients/DogInfo/DogInfo.vue'),
          meta: {
            type: 'residential',
          }
      },
      {
          path: '/dog_info/:id',
          name: 'dog_info_details',
          component: () => import('./components/ResidentialClients/DogInfo/DogInfoDetails.vue'),
          meta: {
            type: 'residential',
          }
      },
      {
          path: '/yard_info',
          name: 'yard_info',
          component: () => import('./components/ResidentialClients/YardInfo/YardInfo.vue'),
          meta: {
            type: 'residential',
          }
      },
      {
          path: '/additional_services',
          name: 'additional_services',
          component: () => import('./components/ResidentialClients/AdditionalServices/AdditionalServices.vue'),
          meta: {
            type: 'residential',
          }
      },
      {
          path: '/invoices',
          name: 'invoices',
          component: () => import('./components/ResidentialClients/Billing/Invoices.vue'),
          meta: {
            type: 'residential',
          }
      },
      {
          path : '/invoices/:id',
          name: 'invoice',
          component: () => import('./components/ResidentialClients/Billing/Invoice.vue'),
          meta: {
            type: 'residential',
          }
      },
      {
          path: '/subscriptions',
          name: 'subscriptions',
          component: () => import('./components/ResidentialClients/Billing/Subscriptions.vue'),
          meta: {
            type: 'residential',
          }
      },
      {
          path: '/subscriptions/:id',
          name: 'subscription',
          component: () => import('./components/ResidentialClients/Billing/Subscription.vue'),
          meta: {
            type: 'residential',
          }
      },
      {
          path: '/tips',
          name: 'tips',
          component: () => import('./components/ResidentialClients/Billing/Tips/Tips.vue'),
          meta: {
           type: 'residential',
          }
      },
      {
          path: '/payments',
          name: 'payments',
          component: () => import('./components/ResidentialClients/Billing/Payments.vue'),
          meta: {
            type: 'residential',
          }
      },
      {
          path: '/payments/:id',
          name: 'payment',
          component: () => import('./components/ResidentialClients/Billing/Payment.vue'),
          meta: {
            type: 'residential',
          }
      },
      {
          path: '/payment_methods',
          name: 'payment_methods',
          component: () => import('./components/ResidentialClients/Billing/PaymentMethods'),
          meta: {
            type: 'residential',
          }
      },
      {
          path: '/cleanups',
          name: 'cleanups',
          component: () => import('./components/ResidentialClients/Scheduler/Cleanups.vue'),
          meta: {
            type: 'residential',
          }
      },
      {
          path : '/notifications',
          name: 'notifications',
          component: () => import('./components/notifications/Index.vue'),
          meta: {
            type: 'residential',
          }
      },
      {
          path: '/notification_settings',
          name: 'notification_settings',
          component: () => import('./components/settings/NotificationSettings.vue'),
          meta: {
            type: 'residential',
          }
      },
      {
          path: '/terms_of_service/:slug',
          name: 'terms_of_service',
          component: () => import('./components/settings/TermsOfService.vue'),
          meta: {
            type: 'residential',
          }
      },
      {
          path: '/change_password',
          name: 'change_password',
          component: () => import('./components/settings/ChangePassword.vue'),
          meta: {},
      },
      {
          path: '/change_email',
          name: 'change_email',
          component: () => import('./components/settings/ChangeEmail.vue'),
          meta: {
              title: 'Change Mail'
          }
      },
      {
          path: '/change_email/:token',
          name: 'change_email_token',
          component: () => import('./components/settings/ConfirmChangeEmail.vue'),
          meta: {
              title: 'Change Mail'
          }
      },

    {
        path: '/commercial_contact_info',
        name: 'commercial_contact_info',
        component: () => import('./components/CommercialClients/ContactAndBillingInfo/ContactAndBillingInfo.vue'),
        meta: {
            title: 'Contact Info',
            type: 'commercial',
        },
    },
    {
        path: '/commercial_billing_info',
        name: 'commercial_billing_info',
        component: () => import('./components/CommercialClients/ContactAndBillingInfo/ContactAndBillingInfo.vue'),
        meta: {
            title: 'Billing Info',
            type: 'commercial',
        },
    },
    {
        path: '/commercial_service_address',
        name: 'commercial_service_address',
        component: () => import('./components/CommercialClients/ServiceAddress/ServiceAddress.vue'),
        meta: {
            title: 'Service Address',
            type: 'commercial',
        },
    },
    {
        path: '/commercial_work_areas',
        name: 'commercial_work_areas',
        component: () => import('./components/CommercialClients/WorkAreas/WorkAreas.vue'),
        meta: {
            title: 'Work Areas',
            type: 'commercial',
        },
    },
    {
        path: '/commercial_billing',
        name: 'commercial_billing',
        component: () => import('./components/CommercialClients/Billing/Billing.vue'),
        meta: {
            title: 'Billing',
            type: 'commercial',
        },
    },
    {
        path: '/commercial_tips',
        name: 'commercial_tips',
        component: () => import('./components/CommercialClients/Tips/Tips.vue'),
        meta: {
            title: 'Tips',
            type: 'commercial',
        },
    },
    {
        path: '/commercial_invoice/:commercial_location_id/:id',
        name: 'commercial_invoice',
        component: () => import('./components/CommercialClients/Billing/InvoiceShow.vue'),
        meta: {
            title: 'Invoice',
            type: 'commercial',
        },
    },
    {
        path: '/commercial_subscription/:commercial_location_id/:id',
        name: 'commercial_subscription',
        component: () => import('./components/CommercialClients/Billing/SubscriptionShow.vue'),
        meta: {
            title: 'Subscription',
            type: 'commercial',
        },
    },
    {
        path: '/commercial_payment/:commercial_location_id/:id',
        name: 'commercial_payment',
        component: () => import('./components/CommercialClients/Billing/PaymentShow.vue'),
        meta: {
            title: 'Payment',
            type: 'commercial',
        },
    },
    {
        path: '/commercial_additional_services',
        name: 'commercial_additional_services',
        component: () => import('./components/CommercialClients/AdditionalServices/AdditionalServices.vue'),
        meta: {
            title: 'Additional Services',
            type: 'commercial',
        },
    },
    {
        path: '/commercial_schedule',
        name: 'commercial_schedule',
        component: () => import('./components/CommercialClients/Schedule/Schedule.vue'),
        meta: {
            title: 'Schedule',
            type: 'commercial',
        },
    },
    {
        path: '/:organization/public_credit_card/:id',
        name: 'public_credit_card',
        component: () => import('./components/PublicCreditCard'),
        meta: {
            title: 'Add Credit Card'
        },
    },
    {
        path: '/:organization/private_credit_card/:id',
        name: 'private_credit_card',
        component: () => import('./components/PublicCreditCard'),
        meta: {
            title: 'Add Credit Card'
        },
    },
    {
        path: "/no_premissions",
        name: "no_premissions",
        component: () => import("./components/NoPermissions.vue"),
        meta: {
            title: "No Permissions"
        }
    },
    {
        path: "*",
        name: "page_not_found",
        component: () => import("./components/PageNotFound.vue"),
        meta: {
            title: "Page Not Found"
        }
    }
  ]
});

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['login', 'reset_password', 'reset_password_token','register',
    'thank_you', "not_available", "thank_you_monthly", "thank_you_not_available", "public_credit_card", "private_credit_card"];
    const specialPages = ['terms_of_service', 'public_credit_card', 'private_credit_card'];
    const authRequired = !publicPages.includes(to.name);
    const loggedIn = localStorage.getItem('sweep_client_token');
    store.commit(REFRESH)
    
    if (
        loggedIn &&
        to.name === 'register' &&
        to.params &&
        to.params.organization && 
        store &&
        store.getters &&
        store.getters.currentUser &&
        store.getters.currentUser.organization_slug &&
        to.params.organization !== store.getters.currentUser.organization_slug
    ) {
        store.commit('logOut')
        return next();
    }

    if (
        loggedIn &&
        to.name === 'public_credit_card' &&
        to.params &&
        to.params.organization && 
        store &&
        store.getters &&
        store.getters.currentUser &&
        store.getters.currentUser.organization_slug &&
        to.params.organization !== store.getters.currentUser.organization_slug
    ) {
        store.commit('logOut')
        return next();
    }

    if (
        loggedIn &&
        to.name === 'private_credit_card' &&
        to.params &&
        to.params.organization && 
        store &&
        store.getters &&
        store.getters.currentUser &&
        store.getters.currentUser.organization_slug &&
        to.params.organization !== store.getters.currentUser.organization_slug
    ) {
        store.commit('logOut')
        return next();
    }

    if (authRequired && !loggedIn && !specialPages.includes(to.name)) {
        store.commit('refreshAuth')
        return next('/login');
    }

    if (!authRequired && loggedIn && !specialPages.includes(to.name)) {
        store.commit('refreshAuth')
        return next('/');
    }

    next();
});

router.beforeEach((to, from, next) => {
    const loggedIn = localStorage.getItem('sweep_client_token')
    if (loggedIn) { store.dispatch('checkAuth') }
    next();
});

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.type && to.meta.type !== store.getters.clientType) {
        return next('/');
    }
    next();
});

router.beforeEach((to, from, next) => {
    // Permissions for Tips
    const loggedIn = localStorage.getItem('sweep_client_token');
    const tipsEnabled = store.getters.tipsEnabled;
  
    if (
        loggedIn &&
        !tipsEnabled &&
        ['/tips', '/commercial_tips'].includes(to.path)
    ) {
        next("/no_premissions")
    } else {
        next()
    }
});

export default router;
